export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Poll-Gray-1cff5373aa611feec0ef0a6e25d6c8b3.svg";